<template>
    <div>
        <AppointmentStatus
            v-if="reportId == CREPORT.TYPE.APPOINTMENT_BY_STATUS"
            :data="data"
        />
        <SalesByAppointmentType
            v-if="reportId == CREPORT.TYPE.SALES_BY_APPOINTMENT_TYPE"
            :data="data"
        />
        <AppointmentLog
            v-if="reportId == CREPORT.TYPE.APPOINTMENT_LOG"
            :data="data"
        />
        <PendingAppointments
            v-if="reportId == CREPORT.TYPE.PENDING_APPOINTMENTS"
            :data="data"
        />
        <AppointmentDuration
            v-if="reportId == CREPORT.TYPE.APPOINTMENT_DURATION"
            :data="data"
        />
    </div>
</template>
<script>
import CREPORT from "@/constants/report.js";
import AppointmentStatus from "@/module/report/module/schedule/appointment_by_status";
import SalesByAppointmentType from "@/module/report/module/schedule/sales_by_appointment_type";
import AppointmentLog from "@/components/report-schedule/appointment-log";
import PendingAppointments from "@/components/report-schedule/pending-appointments";
import AppointmentDuration from "@/components/report-schedule/appointment-duration";

export default {
    components: {
        AppointmentStatus,
        SalesByAppointmentType,
        AppointmentLog,
        PendingAppointments,
        AppointmentDuration
    },
    computed: {
        reportId() {
            return this.$route.params.id;
        }
    },
    props: {
        data: {
            default() {},
            type: Object
        }
    },
    data() {
        return { CREPORT: CREPORT };
    }
};
</script>
